import { create } from 'zustand';
import type { SystemDeadResponse } from '@/entities/system';

type AppStatus = 'ok' | 'checking' | 'timeout' | 'maintenance';

type State = {
  status: AppStatus;
  maintenanceData?: SystemDeadResponse;
  setStatus: (status: AppStatus, data?: SystemDeadResponse) => void;
};

const useSystemStatusStore = create<State>(set => ({
  status: 'ok',
  setStatus: (status, data) => set({ status, maintenanceData: data }),
}));

export { useSystemStatusStore };
